// removed by extract-text-webpack-plugin
module.exports = {"deviceInfo":"_3XAcv7HuFYaogcp7FBtBz-","nullContainer":"VlGgvCh35vo2cqNoaIxHU","textContainer":"_1H0AGE6djxJQEW9EsK02ZI","searchContainer":"_1fc8raOIvIFvfsXTEl-h8p","title":"_2rQqF5EeW2MTT_1KXY0rh2","iconContainer":"_2PNGUM5zshfuV9c6hKt0Ad","bottomContainer":"_1ojrZcvuc4qLK7T4_tbgbh","tabsContainer":"_3z0bcDLWpT5HcuYCTxTgTQ","spinner":"_3RN414Uy-OJP92HB_lirJG","bouncedelay":"_2BNXL813jh1p4uvkjhNzWL","bounce1":"_12NZelDSY08fBAP6Sj9dVe","bounce2":"_3kOyj823703eNnT0Q8XxUH"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/DeviceInfo/DeviceInfo.less
// module id = 1535
// module chunks = 0